import type { TFunction } from "i18next";
import {
  marketLocationNumberLength,
  validateMarketLocationNumber
} from "../../../../../utils/validateMarketLocationNumber";
import {
  meteringLocationNumberLength,
  validateMeteringLocationNumber
} from "../../../../../utils/validateMeteringLocationNumber";
import { type Meter } from "../../../SiteSetupAssistant.types";

export function validateMeteringOrMarketLocation(
  value: string,
  t: TFunction
): null | string {
  switch (value.length) {
    case marketLocationNumberLength:
      return validateMarketLocationNumber(value, t);
    case meteringLocationNumberLength:
      return validateMeteringLocationNumber(value, t);
    default:
      return `${t("errors.MeteringOrMarketLocation.InvalidLength", {
        amount: value.length
      })}
${t("errors.MeteringOrMarketLocation.ValidationFailedInstructions")}`;
  }
}

export function validateMeter(values: Partial<Meter>, t: TFunction) {
  const errors: Partial<{ [k in keyof Meter]: string | null }> = {
    location_feedin: null,
    location_feedout: null
  };
  if (values.location_feedin) {
    const errorMessage = validateMeteringOrMarketLocation(
      values.location_feedin,
      t
    );
    if (errorMessage) {
      errors.location_feedin = errorMessage;
    }
  }
  if (values.location_feedout) {
    const errorMessage = validateMeteringOrMarketLocation(
      values.location_feedout,
      t
    );
    if (errorMessage) {
      errors.location_feedout = errorMessage;
    }
  }

  return errors;
}
